function optionTrigger() {
  const contactState = $('#contact-state-gda');
  const states = $('[data-js-states-enquery]');
  const statePlaceholder = $('[data-js-state-placeholder]');
  const santContact = $('[data-js-state-sant]');
  const nswContact = $('[data-js-state-nsw]');
  const vicContact = $('[data-js-state-vic]');
  const qldContact = $('[data-js-state-qld]');

  // show and hide enquiry types based on state selection
  if (contactState.length) {
    contactState.on('change', () => {
      states.find('p').addClass('u-none');

      if (
        contactState.val() === 'SA/NT' ||
        contactState.val() === 'SA' ||
        contactState.val() === 'NT'
      ) {
        santContact.removeClass('u-none');
      } else if (contactState.val() === 'NSW') {
        nswContact.removeClass('u-none');
      } else if (contactState.val() === 'VIC') {
        vicContact.removeClass('u-none');
      } else if (contactState.val() === 'QLD') {
        qldContact.removeClass('u-none');
      } else {
        statePlaceholder.removeClass('u-none');
      }
      // clean state enquiry type after change the state value
      states.find('select').val('');
    });
  }
}

export function init() {
  optionTrigger();
}
